// extracted by mini-css-extract-plugin
export default {"badge-button":"Eg9HE","badgeButton":"Eg9HE","badge":"_2Aioj"};